import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/zeit/7c680545/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const PageDescription = makeShortcode("PageDescription");
const Row = makeShortcode("Row");
const Column = makeShortcode("Column");
const Caption = makeShortcode("Caption");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <PageDescription mdxType="PageDescription">
      <p>{`Empty states are useful when something is yet to be populated and is awaiting data or information. Another common use is when a search or filter yields no results.`}</p>
    </PageDescription>
    <h4 {...{
      "id": "status"
    }}>{`Status:`}</h4>
    <p><a parentName="p" {...{
        "href": "/experimental/overview/"
      }}>{`Experimental`}</a></p>
    <h4 {...{
      "id": "maintainer"
    }}>{`Maintainer:`}</h4>
    <p><a parentName="p" {...{
        "href": "https://github.com/vikkipaterson"
      }}>{`Vikki Paterson`}</a>{`, `}<a parentName="p" {...{
        "href": "https://github.com/chloepoulterdesign"
      }}>{`Chloe Poulter`}</a></p>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "58.931750741839764%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAYAAABiDJ37AAAACXBIWXMAAAsSAAALEgHS3X78AAABH0lEQVQoz62Tu26DUAyGee+EpKQt7AzAwBQpOxMbHN4GBgjiKu4utmIKSSo1UpB+/HNsfxzrgDRNE7zrQpbEwMvlDEdFAeX0CTv5APLhCF+qCt+qtpWmzXUnqtnPNbu9DB9zTxRFxJHw1jQNaJoKruuC53ngCwECFQQQ3CTE2otFvu/TWp7nv8C6rsG2bciyDIZhgHEcYeh7GoH8vEb+lkM/rDzHDdAwDAjDEIqiIHAcxxTTNF08RvZJklAOd4bPXddtgZZlQT/van1hQ1VVcL1eF4/C3d0fBvcuQNM0qZiT2IRvRc8R156J8w9AHKcsSxoDheM/E+e5BuMDEEe+B/5HfwJ1XX8fsG1bcByHTo5P+VUtwPWvx9/Uq8I+5vwAe5l+pNbQelYAAAAASUVORK5CYII=')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "Contextual image",
        "title": "Contextual image",
        "src": "/static/4de448d7d480f1566ca04c85ba4a418d/fb070/0.png",
        "srcSet": ["/static/4de448d7d480f1566ca04c85ba4a418d/d6747/0.png 288w", "/static/4de448d7d480f1566ca04c85ba4a418d/09548/0.png 576w", "/static/4de448d7d480f1566ca04c85ba4a418d/fb070/0.png 1152w", "/static/4de448d7d480f1566ca04c85ba4a418d/ef52f/0.png 1685w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <h2 {...{
      "id": "overview"
    }}>{`Overview`}</h2>
    <h4 {...{
      "id": "an-empty-state-consists-of"
    }}>{`An empty state consists of:`}</h4>
    <ul>
      <li parentName="ul">{`An illustration that is relevant to the context or the product`}</li>
      <li parentName="ul">{`A headline text explaining the reason for the empty state`}</li>
      <li parentName="ul">{`A description of the resource contained typically found in the empty location`}</li>
    </ul>
    <p>{`Don’t include the primary call to action in the empty space. The call to action should remain in the same location whether an area is populated or empty. This prevents confusing users as they become familiar with the system.`}</p>
    <Row mdxType="Row">
 <Column colLg={8} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "68.52134146341463%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAOCAYAAAAvxDzwAAAACXBIWXMAAAsSAAALEgHS3X78AAABt0lEQVQ4y61S207bQBDNR1ZIPBZMaYFCEX+Q97aRIpKXfAA/gNTyASD6Vh7axmkcpYQQJ+Br49uu53R3kjh1KlqBOtLRjHeOj8/OuAJAEJHQ+Q/o8xU8yJ3rVFAEQUqp3iFV/TtoBYvQghQGAR0eHtCboyPafrVDzzcNMl5s097r/RJ2dd4/YM6GYdCmsaV4L+nZ2jp9+HjG2uzQsixUq1X0ehaurj7je8dEx2yj3f7GMOd5+dxGR3FM08R1z8Sg9wXO/aRwqAS7qB83IXLAD2NEicTPKOM8jUWp1pj1BeIkw4VJODkHbE/y5QuHb9+9hxdEuLkdYzia4MdgBHvicj0YjjG+czlf39gYjR3Ow1sbn766OL10YN9Plw673S6azQYf5FIWAw4CH2maII4iRNOpWlj+4IqkSHmhhWCjMRMUQswoqhmGoRJMEccxI00zPp/1l5A5Ma8kWK/XmahFIu1IIUkSFtJ5US96q9C935ZiFYKu66qrBgzf94v6b9A8LVqaYa1W4wPP89jlY6BFSw77/T5arRbPwHEc/uJjoE2UHOZ5zjPKsoyH+xTI+d9RWWztf4TW+gUjqhbymRFy0AAAAABJRU5ErkJggg==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Example of an empty state when a search yields no results",
            "title": "Example of an empty state when a search yields no results",
            "src": "/static/6e58f291bcb64fa8f235f8af1d44dbdf/fb070/1.png",
            "srcSet": ["/static/6e58f291bcb64fa8f235f8af1d44dbdf/d6747/1.png 288w", "/static/6e58f291bcb64fa8f235f8af1d44dbdf/09548/1.png 576w", "/static/6e58f291bcb64fa8f235f8af1d44dbdf/fb070/1.png 1152w", "/static/6e58f291bcb64fa8f235f8af1d44dbdf/e8e91/1.png 1312w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "loading": "lazy"
          }}></img>{`
    `}</span>
        <Caption mdxType="Caption">Example of an empty state when a search yields no results</Caption>
 </Column>
    </Row>
    <Row mdxType="Row">
 <Column colLg={8} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "45.73170731707317%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAJCAYAAAAywQxIAAAACXBIWXMAAAsSAAALEgHS3X78AAAAvklEQVQoz6VSiwqDMAz0/z9SrWJ9gG9tq4IZF0iRrZtjKxyXHM01aRvRZZ3nSb+sa10kgojLstAwDMzAOI6MUG6M8XXCL4ZVVVGSJFTXNTVNQ1mWUZqmPldKsYa8bdv3hsLOObLW8unAtm0M0cHAuq6c3xpiEzqJ45i6rvMdAUVRUFmWDHT3ceSrIYy01t4wz3NmGOIwjNv3/XeGGGWeZ8+4fMTyKNCAaZpYvzU8jsPfWwj7vjMkDhr+8wefax9UW743YnhnnQAAAABJRU5ErkJggg==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Example of an empty state when a table has not yet been populated",
            "title": "Example of an empty state when a table has not yet been populated",
            "src": "/static/93e84f1a262897fc1d321ea4cb3e6e2f/fb070/2.png",
            "srcSet": ["/static/93e84f1a262897fc1d321ea4cb3e6e2f/d6747/2.png 288w", "/static/93e84f1a262897fc1d321ea4cb3e6e2f/09548/2.png 576w", "/static/93e84f1a262897fc1d321ea4cb3e6e2f/fb070/2.png 1152w", "/static/93e84f1a262897fc1d321ea4cb3e6e2f/e8e91/2.png 1312w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "loading": "lazy"
          }}></img>{`
    `}</span>
        <Caption mdxType="Caption">
  Example of an empty state when a table has not yet been populated
        </Caption>
 </Column>
    </Row>
    <Row mdxType="Row">
 <Column colLg={8} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "65.2439024390244%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAANCAYAAACpUE5eAAAACXBIWXMAAAsSAAALEgHS3X78AAABoElEQVQ4y62TyWoCQRCGfb8sajSHmfgOUaKC4L7hBoIbxJfxFjWZGcHJA6iXeBERdx3909XQZlwScrDhp7oZ6qOq/inLfr/HtQ6xLHQxtlvoeheKpkFlUlQNWqeDrv55rq6O9vsHmq0W3pqkJru3sV6vOZQDh8Mv3N7dQJKfYLXa2P0eVpsNDqfTpEc8OByQJBnPbg/cHg+8Ph9evF74/H6Mx+MfYK/fh8vlQqFQQDqdRi6XQzabRTaTYTHDY469U6kU6vVXzKZTbFlX5iPeHDgYDCDLModFIhFEolEeo6YYi8UQDAZRKpWw2Wx4MlVFFux2u2Ngn1UoSRIHUrIQQUQkhUIhlMtlzOdzTCYTjEYjPruLQKqQ2ozH40gkElzJZPIQSVRttVrFYrHg0NlsBsMw/g8kibcAVioVrFaro/n9CiQzCCAqOhW1bwYS6CKQTCGX8/k8TyQ3T0XzpTnWarUDUCzFGbDX68Fut3MYOUnDP1U4HEYgEECxWMRyufwbOGX/VaPRQIdth6IoUFX1ouibruvcFHKXKhUS7Vuuvcvf9sFVS0PjKyQAAAAASUVORK5CYII=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Example of an empty state when a slide-over panel hasn't been populated yet",
            "title": "Example of an empty state when a slide-over panel hasn't been populated yet",
            "src": "/static/025e7ae16ddc7fc3f553d098b8d6bc88/fb070/3.png",
            "srcSet": ["/static/025e7ae16ddc7fc3f553d098b8d6bc88/d6747/3.png 288w", "/static/025e7ae16ddc7fc3f553d098b8d6bc88/09548/3.png 576w", "/static/025e7ae16ddc7fc3f553d098b8d6bc88/fb070/3.png 1152w", "/static/025e7ae16ddc7fc3f553d098b8d6bc88/e8e91/3.png 1312w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "loading": "lazy"
          }}></img>{`
    `}</span>
        <Caption mdxType="Caption">
  Example of an empty state when a slide-over panel hasn't been populated yet
        </Caption>
 </Column>
    </Row>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      